import { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

import { ProtectedRoute } from '@/components/ProtectedRoute';

import AppLayout from './_layout';
import { adminRoutes } from './admin/_routes';
import { userRoutes } from './profile/_routes';
import { scopedRoutes } from './scoped/_routes';

const UserHomePage = lazy(() => import('./profile/home'));

export const appRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      ...userRoutes,
      // Before the scoped routes: `/admin` is cross-tenant and must not be read
      // as a tenant slug.
      ...adminRoutes,
      ...scopedRoutes,
      // Default home (user home)
      { index: true, path: '/', element: <UserHomePage /> },
    ],
  },
];
